const STATUS_REVIEWED = "Reviewed";
const STATUS_VERIFIED = "Verified";

export const getDocumentDisplayStatus = (item) => {
  const originalStatus = (item?.status || "").toString().trim();
  const isReviewed = (item?.is_reviewed || "").toString().trim().toUpperCase() === "Y";
  const failureRowCount = Number(item?.failure_row_count);

  // For reviewed files, derive display status from failure row counts.
  if (isReviewed && !Number.isNaN(failureRowCount)) {
    if (failureRowCount === 0) {
      return STATUS_VERIFIED;
    }

    if (failureRowCount > 0) {
      return STATUS_REVIEWED;
    }
  }

  // If not reviewed (or not matching reviewed rules), show original backend status.
  return originalStatus;
};
